import React from "react";
// import "../assets/css/style.css"; // Import main styles
// import "../assets/css/style2.css"; // Import responsive styles
import logo from "../assets/img/logo.png";
import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <>
      <footer
        className="sectionpadding"
        style={{
          backgroundImage: "url(assets/img/webbg2.png)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="outeroffooter">
          <div className="container">
            <div className="row">
              {/* Logo & About Section */}
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                <div className="logoside">
                  <div className="footersocial">
                    <div className="footerlogo">
                      <Link to="/">
                        <img src={logo} alt="StockCod Logo" />
                      </Link>
                    </div>
                    <div className="footeraboutcontent">
                      <p>
                        StockCod: Your trusted digital agency for a decade,
                        delivering exceptional marketing strategies to elevate
                        your brand's online visibility and insights.
                      </p>
                    </div>
                    <ul>
                      <li>
                        <a href="https://www.facebook.com/stock.cod768">
                          <i className="fa fa-facebook-official" aria-hidden="true"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/stock.cod/">
                          <i className="fa fa-instagram" aria-hidden="true"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/company/stockcod">
                          <i className="fa fa-linkedin" aria-hidden="true"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Explore Section */}
              <div className="col-xl-3 col-lg-2 col-md-6 col-sm-12 footerlinkinfo">
                <div className="footerlink">
                  <h3>Explore</h3>
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/about-us">About Us</Link>
                    </li>
                    <li>
                      <Link to="/website-development">Website Development</Link>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Resources Section */}
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 footerlinkinfo">
                <div className="footerlink">
                  <h3>Resources</h3>
                  <ul>
                    <li>
                      <Link to="/contact-us">Contact Us</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/terms-conditions">Terms & Conditions</Link>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Address Section */}
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                <div className="footerlink">
                  <h3>Address</h3>
                  <ul>
                    <li>
                      <a href="https://goo.gl/maps/example">
                        <i className="fa fa-map-marker" aria-hidden="true"></i>{" "}
                        Ghaziabad, Uttar Pradesh Pin:201102
                      </a>
                    </li>
                    <li>
                      <a href="tel:+919540815561">
                        <i className="fa fa-phone" aria-hidden="true"></i> +91-9540 815 561
                      </a>
                    </li>
                    <li>
                      <a href="mailto:contact@stockcod.com">
                        <i className="fa fa-envelope" aria-hidden="true"></i>{" "}
                        contact@stockcod.com
                      </a>
                    </li>
                    <li>
                      <a href="mailto:stockcode245@gmail.com">
                        <i className="fa fa-envelope" aria-hidden="true"></i>{" "}
                        stockcode245@gmail.com
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Footer Bottom Section */}
      <div
        className="footerbottom"
        style={{
          backgroundImage: "url(assets/img/webbg2.png)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <p>
            Copyright © 2024 All Rights Reserved by{" "}
            <a href="https://www.stockcod.com" style={{ color: "#fff" }}>
              @Stockcod.com
            </a>
          </p>
        </div>
      </div>
    </>
  );
}
